import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiTrash2, FiEdit } from "react-icons/fi";

const AddressScreen = () => {
  const navigate = useNavigate();
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    setLoading(true);
    setError("");
    fetch(`${process.env.REACT_APP_API_URL}/api/buyers/addresses`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    })
      .then(res => res.json())
      .then(data => {
        const addressesArr = Array.isArray(data.data) ? data.data : [];
        if (addressesArr.length > 0) {
          setAddresses(addressesArr);
        } else {
          setError(data.message || "Failed to load addresses.");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Network error. Please try again.");
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#F1F3F2]">
      <header className="sticky top-0 z-10 bg-white shadow-sm">
        <div className="relative flex h-14 items-center justify-center px-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="absolute left-4 flex h-9 w-9 items-center justify-center"
            aria-label="Go back"
          >
            <FiArrowLeft className="h-5 w-5 text-gray-800" />
          </button>
          <h1 className="text-base font-bold text-gray-900">Address</h1>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-4 pb-24" style={{ paddingLeft: '8px', paddingRight: '8px' }}>
        {loading ? (
          <div className="text-center text-gray-500">Loading addresses...</div>
        ) : error ? (
          <div className="text-center text-red-500 font-semibold mb-4">{error}</div>
        ) : addresses.length === 0 ? (
          <div className="text-center text-gray-500">No addresses found.</div>
        ) : (
          addresses.map((address, idx) => (
            <div key={address._id || idx} className="rounded-2xl bg-white p-4 shadow-sm text-left mb-4" style={{ borderRadius: '12px' }}>
              <p className="text-sm text-gray-700">
                <span>{address.firstName} {address.lastName}</span>
              </p>
              <p className="text-sm text-gray-700">
                <span>{address.address}</span>
              </p>
              <p className="text-sm text-gray-700">
                <span>{address.city}</span>, <span>{address.state}</span>, <span>{address.country}</span>
              </p>
              <p className="text-sm text-gray-700">
                <span>{address.phoneNumber}</span>
              </p>
              {address.postalCode && (
                <p className="text-sm text-gray-700">
                  <span>Postal Code: {address.postalCode}</span>
                </p>
              )}
              {address.isDefault && (
                <div className="inline-block rounded bg-[#f1f3f2] mt-2">
                  <span className="text-xs font-semibold text-black">DEFAULT ADDRESS</span>
                </div>
              )}
              <div className="flex items-center justify-between mt-2">
                <span
                  className={`text-sm font-semibold ${address.isDefault ? 'text-gray-400' : 'text-black'}`}
                >
                  Set Default
                </span>
                <div className="flex items-center gap-3">
                  <button type="button" className="text-gray-700" aria-label="Delete address">
                    <FiTrash2 className="h-5 w-5 text-[#19C463]" />
                  </button>
                  <button type="button" className="text-gray-700" aria-label="Edit address">
                    <FiEdit className="h-5 w-5 text-[#19C463]" />
                  </button>
                </div>
              </div>
            </div>
          ))
        )}
      </main>

      <div className="fixed bottom-0 left-0 right-0 bg-[#F1F3F2] p-4">
        <button
          type="button"
          className="w-full rounded-full bg-[#19C463] py-3 text-sm font-semibold text-white"
        >
          Add New Address
        </button>
      </div>
    </div>
  );
};

export default AddressScreen;
